<template lang="html">
	<entity-page id="company" v-bind:loading="progress">
		<template slot="header-left">
			<z-check 
				label="Исполнитель по умолчанию" id="is_default" name="is_default" value="1" 
				v-model="company.is_default"
			></z-check>
		</template>
		<template slot="header-right">
			<z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
		</template>
			
		<flex-tabs 
			v-bind:tabs="tabs" v-model="activeTab" min v-if="company.id && company.id != 'new'"
		></flex-tabs>

		<div v-if="activeTab == 'tab-company'">
			<z-input
				v-model="company.name" v-bind:disabled="progress" v-bind:readonly="progress" v-validate="'required'" placeholder="Полное наименование компании"
				name="name" id="name" label="Название" v-bind:error="errors.first('name')" data-vv-name="name" v-bind:data-vv-as="' '"
			></z-input>
			<div class="row">
				<z-input
					v-model="company.inn" v-bind:disabled="progress" v-bind:readonly="progress" class="col-6" v-validate="'required'"
					name="inn" id="inn" label="ИНН" v-bind:error="errors.first('inn')" type="number" data-vv-name="inn" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-model="company.kpp" v-bind:disabled="progress" v-bind:readonly="progress" class="col-6" v-validate="'required'"
					name="kpp" id="kpp" label="КПП" v-bind:error="errors.first('kpp')" type="number" data-vv-name="kpp" v-bind:data-vv-as="' '"
				></z-input>

				<z-input
					v-model="company.checking_account" v-bind:disabled="progress" v-bind:readonly="progress" type="number" class="col-6" v-validate="'required'"
					name="checking_account" id="checking_account" label="Расчётный счёт" v-bind:error="errors.first('checking_account')" data-vv-name="checking_account" v-bind:data-vv-as="' '"
				></z-input>

				<z-input
					v-model="company.correspondent_account" v-bind:disabled="progress" v-bind:readonly="progress" type="number" class="col-6" data-vv-name="correspondent_account" v-bind:data-vv-as="' '"
					name="correspondent_account" id="correspondent_account" label="Корреспонденский счёт" v-bind:error="errors.first('correspondent_account')" v-validate="'required'"
				></z-input>
				<z-input
					v-model="company.bak" v-bind:disabled="progress" v-bind:readonly="progress" class="col-6" v-validate="'required'"
					name="bak" id="bak" label="БАК" v-bind:error="errors.first('bak')" type="number" data-vv-name="bak" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-model="company.bik" v-bind:disabled="progress" v-bind:readonly="progress" class="col-6" v-validate="'required'"
					name="bik" id="bik" label="Бик" v-bind:error="errors.first('bik')" type="number" data-vv-name="bik" v-bind:data-vv-as="' '"
				></z-input>
			</div>
			<z-input
				v-model="company.bank_name" v-bind:disabled="progress" v-bind:readonly="progress" data-vv-name="bank_name" v-bind:data-vv-as="' '"
				name="bank_name" id="bank_name" label="Наименование банка" v-bind:error="errors.first('bank_name')" v-validate="'required'"
			></z-input>
			<div class="row">
				<z-input
					v-model="company.initials" v-bind:disabled="progress" v-bind:readonly="progress" class="col-4" data-vv-name="initials" v-bind:data-vv-as="' '"
					name="initials" id="initials" label="ФИО руководителя" v-bind:error="errors.first('initials')" v-validate="'required'"
				></z-input>
				<z-input
					v-model="company.position" v-bind:disabled="progress" v-bind:readonly="progress" class="col-4" data-vv-name="position" v-bind:data-vv-as="' '"
					name="position" id="position" label="Должность руководителя" v-bind:error="errors.first('position')" v-validate="'required'"
				></z-input>
				<z-input
					v-model="company.on_base" v-bind:disabled="progress" v-bind:readonly="progress" class="col-4" v-validate="'required'"
					name="on_base" id="on_base" label="На основании" v-bind:error="errors.first('on_base')" data-vv-name="on_base" v-bind:data-vv-as="' '"
				></z-input>
			</div>


			<div class="row">
				<z-select 
					label="Активность" name="active" id="active" v-model="company.active" v-bind:required="true" v-validate="'required'" 
					class="col-4" data-vv-name="active" v-bind:data-vv-as="' '" v-bind:error="errors.first('active')"
				>
					<option disabled selected value="">Не выбрано</option>
					<option v-bind:value="1"> Да </option>
					<option v-bind:value="0"> Нет </option>
				</z-select>

				<z-select 
					label="По умолчанию" name="is_default" id="is_default" v-model="company.is_default" v-bind:required="true" v-validate="'required'" 
					class="col-4" data-vv-name="is_default" v-bind:data-vv-as="' '" v-bind:error="errors.first('is_default')"
				>
					<option disabled selected value="">Не выбрано</option>
					<option v-bind:value="1"> Да </option>
					<option v-bind:value="0"> Нет </option>
				</z-select>

				<z-input
					v-model="company.doc_prefix" v-bind:disabled="progress" v-bind:readonly="progress" type="text" class="col-4"
					name="doc_prefix" id="doc_prefix" label="Префикс для документов" v-bind:error="errors.first('doc_prefix')" data-vv-name="doc_prefix" v-bind:data-vv-as="' '"
				></z-input>

			</div>

			<div class="row">
				<z-select 
					label="Компания работает с НДС" name="nds" id="nds" v-model="company.nds" v-bind:required="true" v-validate="'required'" 
					class="col-6" data-vv-name="nds" v-bind:data-vv-as="' '" v-bind:error="errors.first('nds')"
				>
					<option disabled selected value="">Не выбрано</option>
					<option v-bind:value="1"> Да </option>
					<option v-bind:value="0"> Нет </option>
				</z-select>
				<z-input
					v-model="company.nds_value" v-bind:disabled="progress" v-bind:readonly="progress" type="number" class="col-6" v-validate="'required'"
					name="nds_value" id="nds_value" label="Величина НДС (в %)" v-bind:error="errors.first('nds_value')" data-vv-name="nds_value" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-model="company.phone" v-bind:disabled="progress" v-bind:readonly="progress" type="tel" class="col-6" v-validate="'required'" v-bind:mask="'+7 (999) 999-99-99'"
					name="phone" id="phone" label="Контактный телефон" v-bind:error="errors.first('phone')" data-vv-name="phone" v-bind:data-vv-as="' '"
				></z-input>
				<z-input
					v-model="company.email" v-bind:disabled="progress" v-bind:readonly="progress" type="email" class="col-6" v-validate="'required|email'"
					name="email" id="email" label="Контактный email адресс" v-bind:error="errors.first('email')" data-vv-name="email" v-bind:data-vv-as="' '"
				></z-input>
			</div>
		</div>
		<company-address v-show="activeTab == 'tab-addresses'" v-model="company.addresses" v-bind:company-id="company.id"></company-address>
	</entity-page>
</template>
<script>
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	import ToggleCard from '@/components/ToggleCard'
	import ZInput from '@/components/ZInput';
	import EntityPage  from '@/components/EntityPage.vue';
	import FlexTabs from '@/components/FlexTabs';
	import ZSelect from '@/components/ZSelect';
	import ZCheck from '@/components/ZCheck';
	import ZButton     from '@/components/ZButton';
	import CompanyAddress from '../components/CompanyAddress.vue';
	export default {
		components: { EntityPage, ZIconButton, ZInputAutocomplete, ZButton, ToggleCard, FlexTabs, ZInput, ZSelect, ZCheck, CompanyAddress },
		data() {
			return {
				addresses_to_delete: [],
				address: null,
				company: {},
				companyDefault: {
					name: '',
					inn:  '',
					kpp:  '',
					bak:  '',
					initials: '',
					position: '',
					on_base:  '',
					sort:       100,
					is_default: 0,
					checking_account:      '',
					correspondent_account: '',
					bik: '',
					nds: null,
					bank_name: '',
					email: '',
					phone: '',
					address_to_attach: [],
				},
				activeTab: 'tab-company',
				tabs: [
					{name: "tab-company",   label: "Компания"},
					{name: "tab-addresses", label: "Адреса"},
				],
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['load-company-card'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Компании
			 */
			companies() {
				return this.$store.state.companies.companies;
			},
			/**
			 * Типы адреса
			 */
			addressTypes() {
				return this.$store.state.address.address_types;
			}
		},
		watch: {
			'$route.params.company_id'() {
				this.getCompany();
				this.$store.commit('openRightPanel');
			},
		},
		created() {
			this.init();
		},
		methods: {
			/**
			 * Шаг назад с возвратом на предидущую страницу
			 */
			back() {
				this.$router.push({name: 'Companies', params: this.$route.params, query: this.$route.query});
			},
			/**
			 * Инициализация компонента
			 */
			async init(){
				this.company = Object.assign({}, this.companyDefault);
				await this.getAddressTypes();
				if (this.$route.params.company_id && this.$route.params.company_id != 'new') this.getCompany();
				this.$store.commit('openRightPanel');
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.company_id != 'new') this.putCompany();
					else this.postCompany();
				})
			},
			/**
			 * Получение типов адреса
			 */
			getAddressTypes() {
				return this.$store.dispatch('address/getAddressTypes');
			},
			/**
			 * Получение компании
			 */
			getCompany() {
				this.$store.commit('showProgressBar', 'load-company-card');
				return this.$store.dispatch('companies/getCompany', {id: this.$route.params.company_id}).then((response) => {
					if (response && response.addresses && this.addressTypes) response.addresses.forEach(address => {
						address.type_name = this.addressTypes.find(type => parseInt(type.id) == parseInt(address.type_id)).name;
					});
					this.company = Object.assign({}, response);
					return this.company;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-company-card'));
			},
			/**
			 * Добавление компании
			 */
			postCompany() {
				this.$store.commit('showProgressBar', 'load-company-card');
				this.$store.dispatch('companies/postCompany', this.company).then(r => {
					if (!r) return;
					this.$root.$emit('reload-table', 'companies');
					this.$router.replace({name: 'Companies'});
				}).finally(() => this.$store.commit('hideProgressBar', 'load-company-card'));
			},
			/**
			 * Изменение компании
			 */
			putCompany() {
				this.$store.commit('showProgressBar', 'load-company-card');
				this.$store.dispatch('companies/putCompany', this.company).then(r => {
					if (!r) return;
					this.getCompany();
					this.$root.$emit('reload-table', 'companies');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-company-card'));
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Company.vue?18e237b2